module.exports = __webpack_public_path__ + "static/media/back-arrow-brand-refresh.0cae9382.svg";